import axios from "axios";
import { baseURLs } from "../../../Axios";
import { downloadFile } from "../../../Helpers/helpers";
import { getAccessToken } from "../../../Utility/tokenUtils";
import api from "../../../api";
import * as actionTypes from "./actionTypes";

const entriesAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACCESS_CONTROL_BASE_URL
});

const types = ["Student", "Teacher", "Staff", "Visitor"]

const getEntriesList = (seed = 0, count = 20, paramsObj = {}, download = false) => {

  let params = "";
  paramsObj.sort = paramsObj.sort ?? "updatedAt";
  paramsObj.order = paramsObj.order ?? -1;
  if (paramsObj) {
    Object.keys(paramsObj).forEach((key) => {
      // console.info(key, paramsObj[key],"DATA")
      let value;
      if (key.includes('Time')) {
        const a = new Date(paramsObj[key])
        value = a.toISOString()
      } else {
        // console.info(key, paramsObj[key], "DATA")
        if (key == 'state' && paramsObj[key]) value = paramsObj[key].replaceAll(" ", "")
        else value = paramsObj[key]
      }

      if (paramsObj[key]) {
        params += "&" + key + "=" + value
      }

    });
  }
  const token = getAccessToken();
  if (download) {
    return (async () => {
      await axios.get(
        `${process.env.REACT_APP_ACCESS_CONTROL_BASE_URL}${api.entries.get}?seed=${seed}&count=${count}${params}&download=true`,
        { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" }
      )
        .then((response) => {
          const href = URL.createObjectURL(response.data);
          downloadFile(href, 'Entries' + new Date().toISOString() + ".xlsx")
          URL.revokeObjectURL(href);
        })
    })().catch(err => {
      console.error(err);
    });
  }

  return async (dispatch) => {

    await axios.get(
      `${process.env.REACT_APP_ACCESS_CONTROL_BASE_URL}${api.entries.get}?seed=${seed}&count=${count}${params}`,
      { headers: { Authorization: `Bearer ${token}` } },
    )
      .then((response) => {

        dispatch({
          type: actionTypes.ENTRIES_UPDATE_STATE,
          data: {
            entriesData: response.data.data,
            seed,
            filters: paramsObj
          },
        });

      });
  };
};

const getVisitorData = (id) => {

  const token = getAccessToken();
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ENTRIES_UPDATE_STATE,
      data: { visitorData: 'loading' },
    });
    const res = await axios.get(
      `${process.env.REACT_APP_MOCK_API_URL}${api.entries.mock.visitor}?rollNumber=${id}`,
      { headers: { "x-api-key": process.env.REACT_APP_MOCK_API_APIKEY } },
    )
    const visitorData = res?.data
    // const visitorData = {
    //   "rollNumber": "11119911",
    //   "name": "Mansi Malhotra",
    //   "email": "ssi.dev@trential.com",
    //   "mobile": "9876543210",
    //   "photo": "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",
    //   "address": "A-111, Hall 4",
    //   "dob": "31-12-1999",
    //   "permanentAddress": "House no. 5, Agra",
    //   "department": "Computer Science & Engineering",
    //   "thesisProfessor": "Prof. Sandeep Shukla",
    //   "thesisProfessorContact": "9874561230",
    //   "parentsContact": "8794546120",
    //   "emergencyContact": "7894561230",
    //   "degree": "B. Tech. / CE",
    //   "expiryDate": "01-05-2025",
    //   "bloodGroup": "AB-",
    //   "parentName": "Sunil Yadav",
    //   "tag": "Student"
    // }

    dispatch({
      type: actionTypes.ENTRIES_UPDATE_STATE,
      data: { visitorData: res.data },
    });

    return res;

  };
};
// return new Promise((resolve, reject) => {
//   let zones = fakesToSearch.filter(x => {
//     return new RegExp(search, 'ig').test(x)
//   })
//   resolve({
//     data: {
//       code: 0,
//       data: {
//         list: zones.slice(seed, seed + count),
//         total: zones.length
//       }
//     }
//   })
// })
const getZoneList = async (seed = 0, count = 5, search = "") => {
  const token = getAccessToken();
  return axios.get(
    `${process.env.REACT_APP_ACCESS_CONTROL_BASE_URL}${api.zones.get}?name=${search}`,
    { headers: { Authorization: `Bearer ${token}` } },
  )
    .then((response) => {
      // console.log(response.data)
      return {
        list: response.data.data,
        total: response.data.data.length
      }

    });
};

const getVisitsData = () => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.get(
      `${baseURLs.verifier}${api.misc.visitsConfigs}?configType=typeOfVisitor&seed=0&count=500`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.data
    }
  };
}

const getPurposesData = () => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.get(
      `${baseURLs.verifier}${api.misc.visitsConfigs}?configType=visitPurpose&seed=0&count=500`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.data
    }
  };
}


const addPurposeData = (reqData) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.post(
      `${baseURLs.verifier}${api.entries.purposes}`,
      reqData,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.data;
    }
  };
}

const updatePurposeData = (id, purpose) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.put(
      `${baseURLs.verifier}${api.entries.purposes}/${id}`,
      purpose,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.message;
    }
  };
}

const deletePurposeData = (id) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.delete(
      `${baseURLs.verifier}${api.entries.purposes}/${id}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.message;
    }
  };
}

const getTypeList = (seed = 0, count = 5, search) => {
  return new Promise((resolve, reject) => {

    resolve({
      data: {
        code: 0,
        data: {
          list: types.slice(seed, seed + count),
          total: types.length
        }
      }
    })
  })
    .then((response) => {
      return response.data.data

    });
};

const getCheckpointList = async (id) => {
  const token = getAccessToken();
  return axios.get(
    `${process.env.REACT_APP_ACCESS_CONTROL_BASE_URL}${api.zones.get}/${id}`,
    { headers: { Authorization: `Bearer ${token}` } },
  ).then((response) => {

    return {
      list: response.data.data.checkpoints,
      total: response.data.data.checkpoints.length
    }

  });
};

const signOffManual = ({ id, reason, checkpoint }) => {
  const token = getAccessToken();
  return async (dispatch) => {
  const result = await axios.put(
    `${process.env.REACT_APP_ACCESS_CONTROL_BASE_URL}${api.entries.get}/${id}/exit`,
    {
      reason,
      checkpoint
    },
    { headers: { Authorization: `Bearer ${token}` } },
  )
  console.info(result?.data?.code,'RESPONSE')
    return result?.data?.code
  }
};

const getEntriesGraphStats = (paramsObj = {}) => {
  const { type, zone, period, from, to } = paramsObj
  let queryString = ""
  if (period && from && to) {
    queryString += `?period=${period}&inTimeFrom=${from}&inTimeTo=${to}`
  }
  return async (dispatch) => {
    const response = await axios.get(
      `${baseURLs.verifier}${api.entries.graphs}/${type}/${zone}${queryString}`,
    );
    if (response?.data?.code === 0) {
      return response.data.data
    }
  };
}


const updateVisitsData = (data) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.put(
      `${baseURLs.verifier}${api.entries.visits}`,
      data,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    // if (response?.data?.code === 0)
    // {
    //   return response.data.data
    // }
  };
}

const getVisitsConfigs = (configType) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.get(
      `${baseURLs.verifier}${api.misc.visitsConfigs}?configType=${configType}&seed=0&count=500`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (response?.data?.code === 0) {
      return response.data.data
    }
  };
}

const createVisitsConfig = (reqData) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.post(
      `${baseURLs.verifier}${api.misc.visitsConfigs}`,
      reqData,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if(response?.data?.code === 0) {
      return "success"
    }
  };
}

const updateVisitsConfig = (id, reqData) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.put(
      `${baseURLs.verifier}${api.misc.visitsConfigs}/${id}`,
      reqData,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if(response?.data?.code === 0) {
      return "success"
    }
  };
}

const deleteVisitsConfig = (id) => {
  const token = getAccessToken();
  return async (dispatch) => {
    const response = await axios.delete(
      `${baseURLs.verifier}${api.misc.visitsConfigs}/${id}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if(response?.data?.code === 0) {
      return "success"
    }
  };
}


export {
  getEntriesList,
  getVisitorData,
  getPurposesData,
  addPurposeData,
  updatePurposeData,
  deletePurposeData,
  getVisitsData,
  getZoneList,
  getTypeList,
  getCheckpointList,
  signOffManual,
  getEntriesGraphStats,
  updateVisitsData,
  getVisitsConfigs,
  createVisitsConfig,
  updateVisitsConfig,
  deleteVisitsConfig
};


